import { baseUrl } from "services";

export const createBackgroundImage = (imgPath) => {
  return encodeURI(baseUrl + imgPath)?.replace(/%5C/g, "//");
};
